import { dFix } from '../Settings';
import { OrderAdjustment, OrderItem } from '../types/Order';
import { calculateOrderItemSummary } from './Cart';
import { useOrderItemList, useOrderItemListRows } from './OrderItemList';

interface BasicCheckOutArgs {
	adjustment: OrderAdjustment[];
	orderItem: OrderItem[];
	orderId: string;
}

export const useBasicCheckOut = ({ adjustment, orderItem, orderId }: BasicCheckOutArgs) => {
	const totalCoupons = adjustment.reduce((acc, code) => {
		if (code.displayLevel !== 'Order') {
			return acc;
		}
		return acc + dFix(code.amount || 0) * -1;
	}, 0);

	const orderItemList = useOrderItemList(orderItem, orderId);
	const orderItemListRows = useOrderItemListRows(orderItemList.data);

	const orderItemListRowsSorted = [...orderItemListRows.data].sort((a, b) => {
		const timeA = new Date(
			a.orderItemListRow.orderItem.lastUpdateDate || a.orderItemListRow.orderItem.createDate || 0
		).getTime();
		const timeB = new Date(
			b.orderItemListRow.orderItem.lastUpdateDate || b.orderItemListRow.orderItem.createDate || 0
		).getTime();
		return timeB - timeA;
	});

	const { totalDiscount, totalPriceWithoutOffer } = orderItemListRowsSorted.reduce(
		(acc, row) => {
			const { discount, priceWithoutOffer } = calculateOrderItemSummary({
				offerPrice: row.details.prices.offer || 0,
				displayPrice: row.details.prices.list || 0,
				totalAdjustment: row?.orderItemListRow.totalAdjustment.totalAdjustment,
				orderItemPrice: row?.orderItemListRow.price.orderItemPrice,
			});
			return {
				totalDiscount: acc.totalDiscount + discount,
				totalPriceWithoutOffer: acc.totalPriceWithoutOffer + priceWithoutOffer,
			};
		},
		{ totalDiscount: 0, totalPriceWithoutOffer: 0 }
	);

	return {
		totalCoupons,
		totalDiscount,
		totalPriceWithoutOffer,
		orderItemList,
		orderItemListRows,
		orderItemListRowsSorted,
		loadingOrderItemListRows: orderItemListRows.loading,
	};
};
